<template>
  <nav class="navbar navbar-expand-md navbar-dark bg-primary mb-0">
    <img
      :src=companyIconFileName      
      class="d-inline-block align-text-bottom"
      border-color="red"
      width="65"
      height="65"
    />
    
    <a class="navbar-brand company-name">{{ companyName }}</a>
    
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNavAltMarkup"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
      <div id="aboutId" class="navbar-nav fw-bold">
        <!-- 🔥 CHANGED: v-show instead of v-if -->
        <router-link
          v-show="isLoggedIn"
          to="/expiryDatesScan"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Dashboard</router-link>
        
        <!-- 🔥 CHANGED: Show Login only when NOT logged in -->
        <router-link
          v-show="!isLoggedIn"
          to="/login"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Login</router-link>

        <router-link
          v-show="isLoggedIn"
          to="/schedule"
          name="schedule"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Schedule</router-link>
        
        <router-link
          v-show="isLoggedIn"
          to="/securityOfficers"
          name="securityOfficers"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Officers</router-link>

        <router-link
          v-show="isLoggedIn"
          to="/companies"
          name="companies"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Companies</router-link>

        <router-link
          v-show="isLoggedIn"
          to="/sites"
          name="sites"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Sites</router-link>

        <router-link
          v-show="isLoggedIn"
          to="/siteSchedule"
          name="siteSchedule"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Site Schedule</router-link>

        <router-link
          v-show="isLoggedIn"
          to="/jobCalls"
          name="jobCalls"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Calls</router-link>

        <router-link
          v-show="isLoggedIn"
          to="/changepassword"
          name="changepassword"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Password</router-link>

        <!-- 🔥 CHANGED: Show Logout only when logged in -->
        <router-link
          v-show="isLoggedIn"
          to="/pays"
          name="pays"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Pays</router-link>

         <router-link
          v-show="isLoggedIn"
          to="/logout"
          name="logout"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
        >Logout</router-link>
      </div>
    </div>
  </nav>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
  components: {},
  devServer: {
    https: true,
  },
  data() {
    return {
      companyName: localStorage.getItem("companyNameForHeader"),
      companyIconFileName: "" + localStorage.getItem("companyIconFile"),
      isLoggedIn: false, // 🔥 NEW: Track login status
      brandingLoaded: false,
    };
  },
  methods: {
    // 🔥 NEW: Check login status from token
    checkLoginStatus() {
      const token = localStorage.getItem("token");
      this.isLoggedIn = !!token && token.length > 0;
      
      // Update the old flag for compatibility
      localStorage.setItem("isLogginSuccessfull", this.isLoggedIn ? "true" : "false");
      
      //console.log("Login status updated:", this.isLoggedIn); // For debugging
    },

    logout() {
      this.isLoggedIn = false;
      localStorage.removeItem("token");
      localStorage.setItem("isLogginSuccessfull", "false");
    },

    setLoginStatus(message: boolean) {
      this.isLoggedIn = message;
      localStorage.setItem("isLogginSuccessfull", message ? "true" : "false");
    },

    onMessage() {
      // handle the event
    },

    Carousel() {
      window.addEventListener("message", this.onMessage);
    },

    async loadBranding() {
      try {
        const tenantId = window.location.hostname.split('.')[0].toUpperCase();
        const requestUrl = (window as any).VUE_APP_API_KEY + "Login/Settings";
        
        const response = await fetch(requestUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Tenant-ID': tenantId
          }
        });
        
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const branding = await response.json();

        (window as any).SITE_TITLE = branding.branding.companyName;
        (window as any).COMPANY_NAME = branding.branding.companyName;
        (window as any).COMPANY_NAME_FOR_HEADER = branding.branding.companyName;
        (window as any).ICON_FILE = branding.faviconFile;
        (window as any).WHATSAPP_NUMBER = branding.branding.mobileNo;

        localStorage.setItem("companyNameForHeader", branding.branding.companyName);
        localStorage.setItem("companyIconFile", branding.faviconFile);
        localStorage.setItem("whatsappNumber", branding.branding.mobileNo);
        localStorage.setItem("companyName", branding.branding.companyName);

        window.dispatchEvent(new Event('brandingLoaded'));

        this.companyName = branding.branding.companyName;
        this.companyIconFileName = branding.faviconFile;

        document.title = branding.branding.companyName;
        this.brandingLoaded = true;
        
      } catch (error) {
        console.error("Failed to load branding:", error);
        this.brandingLoaded = true;
      }
    }
  },

  computed: {
    // 🔥 NEW: Watch token changes
    token() {
      return localStorage.getItem("token");
    }
  },

  watch: {
    // 🔥 NEW: Auto-update when token changes
    token(newToken, oldToken) {
      if (newToken !== oldToken) {
        this.checkLoginStatus();
      }
    }
  },

  mounted() {
    // 🔥 Check login status on mount
    this.checkLoginStatus();

    // 🔥 Listen for login events from other components
    window.addEventListener('login-status-changed', this.checkLoginStatus);
    
    // 🔥 Listen for changes from other tabs
    window.addEventListener('storage', (event) => {
      if (event.key === 'token') {
        this.checkLoginStatus();
      }
    });

    this.loadBranding();
  },

  beforeUnmount() {
    // Clean up
    window.removeEventListener('login-status-changed', this.checkLoginStatus);
    window.removeEventListener('storage', this.checkLoginStatus);
  }
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 10px;
  text-align: right;
  background: rgb(50, 119, 223);
}

nav a {
  font-weight: bold;
  font-size: large;
  color: #eff0f1;
  padding: 10px;
  text-align: left;
}

.company-name {
  color: black;
  padding-right: 0em;
  font-weight: bold;
  text-align: left;
  vertical-align: text-top;
  font-size: 23px;
}

nav a.router-link-exact-active {
  color: yellow;
  border-collapse: separate;
}
</style>